// src/app/_utility/interceptor/jwt.interceptor.fn.ts
// MIGRATION: replaced class-based HttpInterceptor with functional HttpInterceptorFn
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { switchMap } from 'rxjs';
import { AuthService } from '../../_services';
import { environment } from '../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (req.url.startsWith(environment.host) && !req.url.includes('login')) {
    let token = auth.token;
    let request = req.clone({})

    if(timezone) {
      request = req.clone({ setHeaders: { 'X-Timezone': timezone } });
    }

    if (token) {
      if (auth.isExpiredToken) {
        console.warn('Auth token is expired');
        return auth.ShowDialog().pipe(
          switchMap((result: any) => {
            if (result && 'auth' in result && 'idToken' in result.auth) {
              token = result.auth.idToken;
              request = request.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
              });
            }
            return next(request);
          })
        );
      } else {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next(request);
      }
    } else {
      return next(request);
    }
  }

  return next(req);
};
